<template>
    <router-view />
</template>

<script>
export default {
  name: 'BarbershopEntryView',
  methods: {
    goToInquiry() {
      this.$router.push('/inquiry')
    },
    goToRegister() {
      this.$router.push('/register')
    },
    goToHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.entry-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.banner-section {
  position: relative;
  width: 100%;
  height: 100vh;
  background-image: url('@/assets/partner-banner-02.png');
  background-size: cover;
  background-position: center;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4); /* 어두운 반투명 레이어 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 0 16px;
  text-align: center;
}

.overlay h2 {
  font-size: 2.2rem;
  font-weight: bold;
  margin: 0.2rem 0;
}

.overlay p {
  font-size: 1.1rem;
  margin: 1rem 0 2rem;
}

.button-group {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.button-group button {
  padding: 14px 28px;
  border-radius: 30px;
  font-size: 16px;
  background-color: transparent;
  border: 2px solid #fff;
  color: white;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}

.button-group button:hover {
  background-color: white;
  color: #000;
}
</style>
